/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import { Container } from "reactstrap";
import SimpleBar from "simplebar-react";
import { Tree } from "react-arborist";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchMemoryItemsInFolder } from "api/queries/file";
import { deleteBulkFile } from "api/mutators/file";

import DeleteModal from "../../Components/Common/DeleteModal";
import FilesList from "./FilesList";
import FileDetail from "./FileDetail";
import TreeNode from "./component/TreeNode";
import { FileDtoItemTypeEnum } from "generated/apiFiles";

const FileManager = () => {
  document.title = "File Manager | AICare";
  const { t } = useTranslation("translation", { keyPrefix: "FILE_MANAGER" });
  const queryClient = useQueryClient();
  const [file, setFile] = useState<any>(null);
  const [active, setActive] = useState<boolean>(false);

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [currentFolderId, setCurrentFolderId] = useState<any>("ee54a3c8-d759-4162-a784-7e9a3d37a944");
  const [currentFolder, setCurrentFolder] = useState<any>({
    id: "ee54a3c8-d759-4162-a784-7e9a3d37a944",
    name: "Materiale",
    title: "Materiale",
    description: "initial folder for filesystem",
    path: "/",
    key: "root",
    type: "folder",
    itemType: FileDtoItemTypeEnum.Folder,
    children: [],
  });

  const [fileSystem, setFileSystem] = useState<any>([
    {
      id: "ee54a3c8-d759-4162-a784-7e9a3d37a944",
      name: "Materiale",
      title: "Materiale",
      description: "initial folder for filesystem",
      path: "/",
      key: "root",
      type: "folder",
      itemType: FileDtoItemTypeEnum.Folder,
      children: [],
    },
  ]);

  const { isPending, data, error } = useQuery({
    queryKey: fetchMemoryItemsInFolder.queryKey([currentFolderId]),
    queryFn: () => fetchMemoryItemsInFolder.queryFn(currentFolderId),

  });

  const mutation = useMutation({
    mutationFn: deleteBulkFile,
    onError: (error: any) => {
      const checkall: any = document.getElementById("checkBoxAll");
      checkall.checked = false;

      queryClient.invalidateQueries({
        queryKey: ["fetchMemoryItemsInFolderForTable"],
      });
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
      toast.error("Error! Files not deleted", { autoClose: 3000 });
    },
    onSuccess: () => {
      const checkall: any = document.getElementById("checkBoxAll");

      checkall.checked = false;

      queryClient.invalidateQueries({
        queryKey: ["fetchMemoryItemsInFolderForTable"],
      });
      queryClient.invalidateQueries({ queryKey: ["fetchMemoryItemsInFolder"] });
      toast.success("Files Deleted Successfully", { autoClose: 3000 });
    },
  });

  const handleDeleteFile = () => {
    if (file) {
      mutation.mutate({ ids: [file.id] });
      setDeleteModal(false);
      setActive(false);
      setFile({});
    }
  };

  function updateTreeWithChildren(node: any, folder: any): any {
    if (node.id === folder.id) {
      return { ...node, children: folder.children };
    } else if (node.children && node.children.length > 0) {
      return {
        ...node,
        children: node.children.map((child: any) =>
          updateTreeWithChildren(child, folder)
        ),
      };
    } else {
      return node;
    }
  }

  const handleFolderClick = async (id: string) => {
    setCurrentFolderId(id);
    setActive(false);
    setFile({});
    console.log("Current Folder ID:", id);
  };

  useEffect(() => {
    if (data && !isPending) {
      setFileSystem((prev: any) => {
        return [updateTreeWithChildren(prev[0], data)];
      });
      setCurrentFolder(data);
    }
  }, [data, isPending]);

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFile}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
            <div
              style={{ minWidth: "15%" }}
              className="file-manager-sidebar minimal-border"
            >
              <div className="p-3 d-flex flex-column h-100">
                <div className="mb-3">
                  <h5 className="mb-0 fw-semibold">{t("FILES_LIST:TITLE")}</h5>
                </div>
                <SimpleBar
                  className="mt-3 mx-n4 px-4 file-menu-sidebar-scroll"
                  style={{ height: "100%" }}
                >
                  <Tree
                    data={fileSystem}
                    disableDrag
                    disableDrop
                    openByDefault={false}
                    onToggle={handleFolderClick}
                  >
                    {TreeNode}
                  </Tree>
                </SimpleBar>
              </div>
            </div>
            <div className="file-manager-content minimal-border w-100 p-3 py-0">
              <div className="mx-n3 pt-4 px-4 file-manager-content-scroll overflow-x-hidden overflow-y-auto">
                <FilesList
                  folder={currentFolder}
                  folderId={currentFolderId}
                  setActive={setActive}
                  setActiveFile={setFile}
                  activeFile={file}
                />
              </div>
            </div>
            <div
              className="file-manager-detail-content minimal-border p-3 py-0"
              style={{ display: active ? "unset" : "none" }}
            >
              <FileDetail
                setActive={setActive}
                activeFile={file}
                setDeleteModal={setDeleteModal}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FileManager;
